import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EpcApiService } from '../../services/epc-api.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrdersState } from '../../../orders/+state/orders.reducer';
import { LoadParkedOrdersList } from '../../../orders/+state/orders.actions';
import { MessageService } from '@pos-app/core-ui';

@Component({
    selector: 'app-landing-main',
    templateUrl: './landing-main.component.html',
    styleUrls: ['./landing-main.component.scss'],
    standalone: false
})
export class LandingMainComponent implements OnInit, AfterViewInit, OnDestroy {
  private landingContentSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public landingContent$ = this.landingContentSubject.asObservable();

  private unSubscribe$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<OrdersState>,
    private epcApiService: EpcApiService,
    private renderer: Renderer2,
    private element: ElementRef,
    private messageService: MessageService
  ) {}
  public ngAfterViewInit(): void {
    this.route.queryParams.pipe(takeUntil(this.unSubscribe$)).subscribe((params) => {
      let id = params['id']; // cedCategoryId
      if (id) {
        this.getCategoryContent(Number(id));
      } else {
        this.getLandingContent();
      }
    });
  }
  public ngOnInit(): void {
    this.store.dispatch(new LoadParkedOrdersList());
    // listen only on landing content area and only handle clicks on anchors with class 'category-item'
    const contentElement = this.element.nativeElement.querySelector('.product-family-content');
    if (contentElement) {
      this.renderer.listen(contentElement, 'click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const anchor: HTMLAnchorElement | null = (target && (target.closest ? target.closest('a.category-item') : null)) as HTMLAnchorElement;

        if (!anchor) {
          return;
        }

        // Only intercept and handle clicks on landing content category links
        event.stopPropagation();
        event.preventDefault();

        const link = anchor.getAttribute('href') || '';
        if (link.includes('category')) {
          const cedCategoryId = link.substring(link.lastIndexOf('/') + 1, link.length);
          this.messageService.trigger('selectCedCategory', cedCategoryId);
        } else {
          this.router.navigateByUrl(link);
        }
      });
    }
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  public getLandingContent(): void {
    this.epcApiService
      .getPageContentStatic('LandingPageContent')
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((result) => {
        this.landingContentSubject.next(
          result.content?.replace(/target=\"_self\"/g, 'target="_self" class="category-item"') || '',
        );
      });
  }

  public getCategoryContent(id: number): void {
    this.epcApiService
      .getStaticContent(id)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((result) => {
        this.landingContentSubject.next(result || '');
        // notify product filter list / tree to select this category immediately
        this.messageService.trigger('selectCedCategory', id);
      });
  }
}

